export default class StatusCriteria {
  constructor(status) {
    this.status = status;
  }

  meetCriteria(activities) {
    return activities.filter(
      (activity) => activity.activity_status_id === this.status,
    );
  }
}
